<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">
        Kolektor
        <div class="card-header-actions">
          <!-- <b-dropdown text="Action" variant="primary" class="mr-1">
            <b-dropdown-item @click="collectortracking()">Activity Tracking</b-dropdown-item>
          </b-dropdown>-->
          <b-button
            variant="btn btn-primary mr-1"
            @click="add"
            v-b-tooltip.hover
            title="input data collector baru"
          >
            <i class="fa fa-file"></i> Tambah Kolektor
          </b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
            <i class="fa fa-file-excel-o"></i> Export
          </button>
          <button class="btn btn-primary mr-1" @click="importxls()">
            <i class="fa fa-cloud-upload"></i> Import
          </button>
           <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i> Filter
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="7">
          <b-input-group>
            <b-input-group-prepend>
              <label>Nama Kolektor</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.collector_name"></b-form-input>
            <b-input-group-append>
              <label class="ml-1 mr-1" style="width:100px;">NIK</label>
            </b-input-group-append>
            <b-form-input v-model="tblData.crewnik" placeholder=""></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>No Hp / Email</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.noemail" placeholder=""></b-form-input>
             <b-input-group-append>
              <label class="ml-1 mr-1" style="width:100px;">No. Identitas</label>
            </b-input-group-append>
            <b-form-input v-model="tblData.ktp" placeholder=""></b-form-input>
          </b-input-group>
          
        </b-col>
        <b-col lg="5">
          <b-input-group>
            <b-input-group-prepend>
              <label>Alamat</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.crewaddr" placeholder=""></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-button class="btn btn-success ml-3" @click="refresh()">
                <i class="fa fa-refresh"></i> Apply
              </b-button>
              <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
                <i class="fa fa-eraser"></i>Clear
              </b-button>
           
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body>
        <!-- <template v-slot:header v-if="filterShow == 'Hide'">
          <b-row>
            <b-col lg="4">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter"
                    >Clear</b-button
                  >
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox
                v-model="filterShow"
                value="Hide"
                unchecked-value="Show"
                switch
              >
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="8">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="2"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox value="crewnik">NIK</b-form-checkbox>
                  <b-form-checkbox value="collector_name"
                    >Nama Kolektor</b-form-checkbox
                  >
                  <b-form-checkbox value="crewmail">Email</b-form-checkbox>
                  <b-form-checkbox value="crewhp">Ho. HP</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template> -->
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          hover
          small
          style="font-size: smaller"
          :items="data"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :filter="filter"
          :filterIncludedFields="filterOn"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
          @row-clicked="rowClicked"
          @filtered="onFiltered"
        >
          <template v-slot:cell(nomor)="data">{{ ((tblData.page-1)*tblData.limit)+(data.index + 1 )}}</template>
          <template v-slot:cell(crewmail)="data">{{
            data.item.crewmail || ""
          }}</template>
          <template v-slot:cell(crewhp)="data">{{
            data.item.crewhp || ""
          }}</template>
          <template v-slot:cell(ktp)="data">{{
            data.item.ktp || ""
          }}</template>
          <template v-slot:cell(crewmaletext)="data">{{
            data.item.crewmaletext || ""
          }}</template>
          <template v-slot:cell(crewdob)="data">{{
            data.item.crewdob || ""
          }}</template>
          <template v-slot:cell(crewaddr)="data">{{
            data.item.crewaddr || ""
          }}</template>
          <template v-slot:cell(crewcity)="data">{{
            data.item.crewcity || ""
          }}</template>
          <template v-slot:cell(crewpost)="data">{{
            data.item.crewpost || ""
          }}</template>

          <template v-slot:cell(action)="data">
            <div class="text-center">
              <a href="javascript:void(0)" @click.stop="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a
                href="javascript:void(0)"
                class="text-danger"
                @click.stop="deleteConfirm(data.item)"
              >
                <i class="fa fa-trash"></i>
              </a>
            </div>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col cols="3">
            <div>
              Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
              to
              <span v-if="tblData.page * tblData.limit > tblData.total">{{
                tblData.total
              }}</span>
              <span v-else>{{ tblData.page * tblData.limit }}</span>
              of {{ tblData.total }} entries
            </div>
          </b-col>
          <b-col cols="3">
            <b-form-group
              label-cols="5"
              label="Limit per page"
              class="text-right mb-0"
            >
              <b-form-select
                :options="[10, 15, 20, 25]"
                :plain="true"
                v-model="tblData.limit"
                style="width: 80px"
              />
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <!-- <b-form-checkbox
              v-model="filterShow"
              value="Hide"
              unchecked-value="Show"
              switch
              class="ml-2"
            >
              <b>{{ filterShow }}</b> Filter
            </b-form-checkbox> -->
          </b-col>
          <b-col cols="3">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
      <b-modal
        v-model="showDelConfirm"
        title="Delete Record?"
        :centered="true"
        @ok="deleteData"
      >
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">
          Warning: You can't undo this action.
        </p>
      </b-modal>
    </b-card>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="7">
        <b-card>
          <div slot="header">
            <h6>Collector - Add/Edit Form</h6>
          </div>
          <!-- <b-input-group>
            <b-input-group-prepend>
              <label>Employee</label>
            </b-input-group-prepend>
            <b-form-input readonly v-model="frmdata.crewinfo"></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuCrewShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>-->
          <b-input-group>
            <b-input-group-prepend>
              <label>NIK</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.crewnik"
              :state="!$v.frmdata.crewnik.$error"
              placeholder="Isi dengan No Induk Karyawan"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Collector Name</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.crewname"
              :state="!$v.frmdata.crewname.$error"
              placeholder="Masukkan nama lengkap"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Jenis Kelamin</label>
            </b-input-group-prepend>
            <b-form-radio-group
              id="radio-group-1"
              v-model="frmdata.crewmale"
              :state="!$v.frmdata.crewmale.$error"
              :options="genders"
              name="radio-options"
            ></b-form-radio-group>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Date Of Birth</label>
            </b-input-group-prepend>
            <b-form-input type="date" v-model="frmdata.crewdob"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Alamat</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.crewaddr"
              :state="!$v.frmdata.crewaddr.$error"
              placeholder="Masukkan alamat"
            ></b-form-input>
          </b-input-group>
          <b-input-group class="sub-section-input">
            <b-input-group-prepend>
              <label class="sub-section-label">Kota</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="frmdata.crewcity"></b-form-input>
            <b-input-group-prepend>
              <label class="sub-section-label text-right mr-2">Kode Pos</label>
            </b-input-group-prepend>
            <b-form-input placeholder v-model="frmdata.crewpost"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Email</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.crewmail"
              :state="!$v.frmdata.crewmail.$error"
              placeholder="Masukkan Alamat Email"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>No HP</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.crewhp"
              :state="!$v.frmdata.crewhp.$error"
              placeholder="Masukkan No HP."
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>No Identitas</label>
            </b-input-group-prepend>
            <b-form-input
              v-model="frmdata.ktp"
              :state="!$v.frmdata.ktp.$error"
              placeholder="Isi dengan no KTP"
            ></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Golongan</label>
            </b-input-group-prepend>
            <b-form-select
              v-model="frmdata.golonganid"
              :options="golKolektor"
              :state="!$v.frmdata.golonganid.$error"
            ></b-form-select>
          </b-input-group>
          <b-input-group @click="showLkuOutsource = true">
            <b-input-group-prepend>
              <label>Vendor Outsourcing</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="frmdata.vendorinfo"
              placeholder="Klik untuk memilih"
              :state="!$v.frmdata.vendoroutsource_id.$error"
            ></b-form-input>
            <b-input-group-append style="height: 35px">
              <b-btn text="Button">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <div slot="footer" style="text-align: center">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()">
              <i class="fa fa-close"></i> {{ $t("close") }} Form
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      v-model="lkuCrewShow"
      size="lg"
      :hide-footer="true"
      title="List of Employee"
      :centered="true"
      :lazy="true"
    >
      <lku-crew @click="onSelectLkuCrew"></lku-crew>
    </b-modal>
    <b-modal
      v-model="showLkuOutsource"
      size="lg"
      :hide-footer="true"
      title="List of Vendor"
      :centered="true"
      :lazy="true"
    >
      <lku-vendoroutsource @click="onSelectLkuVendor"></lku-vendoroutsource>
    </b-modal>
  </div>
</template>


<script>
import moment from "moment";
import lkuCrew from "../lookup/lkuCrew";
import lkuVendoroutsource from "../lookup/lkuVendoroutsource";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required , requiredIf} from "vuelidate/lib/validators";
import kolektor from "../../apis/kolektorkredit";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
      crewnik: { required },
      crewname: { required },
      crewmale: { required },
      crewaddr: { required },
      crewmail: { required },
      crewhp: { required },
      ktp: { required },
      golonganid: { required},
      vendoroutsource_id:{ required: requiredIf(function () {
        return this.requireVendor;
      })},
    },
  },
  data() {
    return {
      showDelConfirm: false,
      showLkuOutsource: false,
      horizontal: true,
      showList: true,
      showForm: false,
      showFilter:true,
      filterShow: "Show",
      filter: null,
      filterOn: [],
      lkuCrewShow: false,
      frmdata: { crewnik: "", crewname: "", crewdob: "", golonganid: "" },
      genders: [
        { text: "Laki-laki", value: "1" },
        { text: "Perempuan", value: "0" },
      ],
      golKolektor: [],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,
        collector_name: "",
        crewnik:"",
        noemail:"",
        ktp:"",
        crewaddr:"",
      },
    };
  },
  components: { lkuCrew, lkuVendoroutsource },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "nomor",
          thStyle: "width:50px",
          label: "No.",
        },
        {
          key: "crewnik",
          label: "NIK",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "ktp",
          label: "No. Identitas (KTP)",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "collector_name",
          label: "Nama Kolektor",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "crewmaletext",
          label: "Jenis Kelamin",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "crewdob",
          label: "Tgl Lahir",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "crewmail",
          label: "Email",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "crewhp",
          label: "Ho. HP",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "crewaddr",
          label: "Alamat",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "crewcity",
          label: "Kota",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "crewpost",
          label: "Kode Pos",
          thClass: "text-center",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:100px",
          thClass: "text-center",
        },
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    requireVendor() {
      const fd = this.golKolektor.find((x) => x.value == this.frmdata.golonganid);
      if (fd.text == "Outsourcing") {
        return true;
      }
      return false;
    },
  },
  async created() {
    this.golKolektor = await kolektor.golongankolektor();
    this.golKolektor.unshift({
      value: "",
      text: "-- Pilih salah satu --",
      disabled: true,
    });
  },
  methods: {
    onFiltered(filteredItems) {
      // console.log('filter',this.filter);
      //       console.log('filterOn',this.filterOn);
      //       console.log('filteredItems',filteredItems);
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },
    clearFilter() {
      this.tblData.collector_name= "";
      this.tblData.crewnik="";
      this.tblData.noemail="";
      this.tblData.ktp="";
      this.tblData.crewaddr="";
      this.$refs.table.refresh()
      // this.filterOn = [];
      // this.filter = "";
    },
    data: async function (ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      const list = await kolektor.list(this.tblData);
      list.map((item, index) => {
        list[index].crewmail = item.crewmail == "0" ? "" : item.crewmail;
        list[index].crewhp = item.crewhp == "0" ? "" : item.crewhp;
        list[index].ktp = item.ktp == "0" ? "" : item.ktp;
        list[index].crewmaletext = item.crewmaletext == "0" ? "" : item.crewmaletext;
        list[index].crewdob = item.crewdob == "0" ? "" : item.crewdob;
        list[index].crewaddr = item.crewaddr == "0" ? "" : item.crewaddr;
        list[index].crewcity = item.crewcity == "0" ? "" : item.crewcity;
        list[index].crewpost = item.crewpost == "0" ? "" : item.crewpost;
      });
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function (data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.showForm = true;
      this.showList = false;
    },
    edit: async function (data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var dt in data) {
        this.frmdata[dt] = data[dt];
      }
      this.frmdata.crewinfo =
        `${data.crewnik ? data.crewnik + " | " : ""}` +
        (data.crewname || data.collector_name);
      this.frmdata.kodelama = data.collector_id;
      this.frmdata.crewdob =
        (this.frmdata.crewdob || "") == ""
          ? null
          : moment(this.frmdata.crewdob).format("YYYY-MM-DD");
      this.frmdata.golonganid = this.frmdata.golonganid || "";
      this.showForm = true;
      this.showList = false;
    },
    save: async function (callback) {
      this.frmdata.iklan = this.frmdata.iklan || "0";
      this.frmdata.koran = this.frmdata.koran || "0";
      if (this.invalidFormdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          await kolektor.save(this.frmdata);
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function () {
      await crud.remove({
        tablename: "collector",
        key: this.model.collector_id,
      });
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    onSelectLkuCrew: async function (_selected) {
      this.frmdata.crewinfo =
        _selected.crewnik.trim() + " | " + _selected.crewname.trim();
      this.frmdata.crewkey = _selected.crewkey;
      this.frmdata.collector_name = _selected.crewname.trim();
      this.lkuCrewShow = false;
    },
    onSelectLkuVendor: async function (_selected) {
      console.log("_selected", _selected);
      this.frmdata.vendoroutsource_id = _selected.vendor_id;
      this.frmdata.vendorinfo =
        _selected.kodevendor.trim() + " | " + _selected.namavendor.trim();

      this.showLkuOutsource = false;
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    async exportxls() {
      try {
        await kolektor.exportxls(this.tblData);
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    async importxls() {
      router.push({ name: "loan.importdatakolektor" });
    },
    close() {
      router.push({ name: "loan.home" });
    },

    async collectortracking() {
      router.push({
        name: "loan.tracking-collector",
      });
    },
  },
};
</script>
